import React from "react";
import { useSelector } from "react-redux";
import { videoInterviewsStateSelector } from "redux/selectors/keyEventsSelector";
import "./scss/vidoesinterviews.scss"
const Vidoes = () => {
  const videoInterviews = useSelector(videoInterviewsStateSelector);
  const geturl = (videoURL: string) => videoURL.replace("watch?v=", "embed/");
  return (
    <div className="videointerviews-vidoes" >
      <iframe
        height="100%"
        width="100%"
        src={geturl(videoInterviews?.url)}
      ></iframe>
    </div>
  );
};

export default Vidoes;
